var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77023 44.179C3.79721 45.2099 5.46226 45.2099 6.48924 44.179L23.4762 27.1266L40.5107 44.2268C41.5377 45.2578 43.2028 45.2578 44.2297 44.2268C45.2567 43.1959 45.2567 41.5244 44.2297 40.4935L27.1952 23.3933L44.0171 6.50654C45.0441 5.47561 45.0441 3.80413 44.0171 2.7732C42.9901 1.74227 41.325 1.74227 40.2981 2.7732L23.4761 19.6599L6.7019 2.82106C5.67492 1.79012 4.00987 1.79012 2.98289 2.82106C1.95592 3.85199 1.95592 5.52346 2.98289 6.5544L19.7571 23.3933L2.77023 40.4457C1.74326 41.4766 1.74326 43.1481 2.77023 44.179Z"
  })));
};
export default SvgCross;